import { inject, Injectable } from '@angular/core';
import { getCorporatePartner } from '@com-delta-idp/mnx-capability-profile-selector-smart';
import {
  ContentFooter,
  ICorporatePartner
} from '@com-delta-idp/mnx-sitewide-footer-ui';
import {
  CountryLanguage,
  HeaderFooterMachCore,
  HeaderFooterMachCoreContentService,
  LoggingService,
  SearchFeedAem
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { BehaviorSubject } from 'rxjs';
import { take } from 'rxjs/operators';
import { FooterAdapterService } from '../adapters/footer.adapter.service';
@Injectable({
  providedIn: 'root'
})
export class HeaderFooterFacadeService {
  headerFooterContent = inject(HeaderFooterMachCoreContentService);
  footerContentAdapter = inject(FooterAdapterService);
  loggingService = inject(LoggingService);
  headerFooterDetails$ = new BehaviorSubject<ContentFooter>(
    {} as ContentFooter
  );

  siteSearchUrl = '/sitesearch?searchTerm=';
  darkSiteLevel = '';
  loaded = false;

  init(): void {
    this.headerFooterContent
      .getHeaderFooterMachCoreContent$()
      .pipe(take(1))
      .subscribe((content: HeaderFooterMachCore) => {
        this.loaded = true;
        if (content?.darkSite?.isEnabled === 'true') {
          this.darkSiteLevel = content.darkSite.level;
        }
        const searchFeed = content?.header?.auxiliaryNavigation?.find(
          (item) => item.id === 'searchfeed'
        ) as SearchFeedAem | undefined;
        if (searchFeed?.aiSiteSearchUrl) {
          this.siteSearchUrl = searchFeed.aiSiteSearchUrl;
        }
        this.headerFooterDetails$.next(this.getHeaderFooterDetails(content));
      });
  }

  getHeaderFooterDetails(
    headerFooterDetails: HeaderFooterMachCore
  ): ContentFooter {
    this.initFooterAdapter(headerFooterDetails);

    const { info } = headerFooterDetails.footer;
    return {
      search: headerFooterDetails.footer.search,
      populartopics: headerFooterDetails.footer.populartopics,
      footercolumns:
        this.footerContentAdapter.getFooterColumnDetails(headerFooterDetails),
      info,
      additionalInfo:
        this.footerContentAdapter.getAdditionalInfo(headerFooterDetails),
      social:
        this.footerContentAdapter.getSocialIconContent(headerFooterDetails),
      feedback:
        Object.keys(headerFooterDetails.footer.feedback).length > 0
          ? headerFooterDetails.footer.feedback
          : null,
      countryLanguage: headerFooterDetails.footer.countrylanguage,
      corpPartner: this.footerContentAdapter.corpPartner,
      businessUser: this.footerContentAdapter.getBusinessUser(),
      isDarkSiteEnabled:
        this.footerContentAdapter.getisDarkSiteEnabled(headerFooterDetails),
      darkSiteBlackTheme: this.isDarkSiteBlackThemeEnabled(headerFooterDetails)
    };
  }

  private initFooterAdapter(headerFooterDetails: HeaderFooterMachCore): void {
    this.footerContentAdapter.deepLinkCacheKey =
      this.footerContentAdapter.urlUtil.getUrlParameter('cacheKeySuffix');
    this.footerContentAdapter.corpPartner = getCorporatePartner(
      this.footerContentAdapter.partnerId
    );
    this.footerContentAdapter.restrictProfileSelector =
      this.footerContentAdapter.commonService.hidingProfileSelector();
    this.footerContentAdapter.setHipmunkCookieForFooter(
      this.footerContentAdapter.restrictProfileSelector
    );
    const disableCLS2 =
      this.footerContentAdapter.appconfig.getConfig('HEADER')?.[
        'APP_DISABLE_CLS2'
      ];
    this.footerContentAdapter.disableCLS =
      disableCLS2 && disableCLS2 === 'true';
    this.footerContentAdapter.getDisableBusinessHomePage(headerFooterDetails);
    this.footerContentAdapter.corpPartner =
      this.footerContentAdapter.corporateMethodService.getCorpPartner(
        this.footerContentAdapter.partnerId,
        this.footerContentAdapter.corpPartner,
        this.footerContentAdapter.deepLinkCacheKey
      );
    if (this.footerContentAdapter.disableCLS) {
      headerFooterDetails.footer.countrylanguage = {} as CountryLanguage;
    }
    this.footerContentAdapter.contentLoaded = true;
    this.footerContentAdapter.switchingAccountService.corporatePartnerChange.subscribe(
      (corpPartner: ICorporatePartner) => {
        this.footerContentAdapter.corpPartner = corpPartner;
        this.footerContentAdapter.corpPartner =
          this.footerContentAdapter.corporateMethodService.getCorpPartner(
            this.footerContentAdapter.partnerId,
            this.footerContentAdapter.corpPartner,
            this.footerContentAdapter.deepLinkCacheKey || ''
          );
      }
    );
  }

  private isDarkSiteBlackThemeEnabled(
    headerFooterDetails: HeaderFooterMachCore
  ): boolean {
    return (
      headerFooterDetails.darkSite.isEnabled === 'true' &&
      headerFooterDetails.darkSite.enableBlackTheme === 'true'
    );
  }

  setCorpPartner(): void {
    try {
      if (this.footerContentAdapter.switchingAccountService.businessAccount) {
        if (this.footerContentAdapter.switchingAccountService.corpPartner) {
          this.footerContentAdapter.corpPartner =
            this.footerContentAdapter.switchingAccountService.corpPartner;
        }
      }
    } catch (error) {
      this.loggingService.log(`Caught Error:  ${error}`);
    }
  }

  footerAfterViewCheck(): void {
    if (this.footerContentAdapter.contentLoaded) {
      this.setCorpPartner();
      this.footerContentAdapter.contentLoaded = false;
    }
  }
}
